import { useTranslation } from 'react-i18next'
import { FileText } from 'lucide-react'

export function IntelEmptyState() {
  const { t } = useTranslation('intel')

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 rounded-xl border border-border bg-card px-6 py-16 text-center">
      <div className="flex size-14 items-center justify-center rounded-full bg-muted">
        <FileText className="size-7 text-muted-foreground" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-base font-semibold text-foreground">{t('emptyTitle')}</p>
        <p className="text-sm text-muted-foreground">{t('emptyBody')}</p>
      </div>
    </div>
  )
}
